module.exports = __webpack_public_path__ + "img/sun-cloud.7919805.svg";